import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

/** Chip-based tag input with suggestions. value = array of strings. */
export default function TagInput({ value = [], onChange, suggestions = [], testId = "tag-input" }) {
  const [draft, setDraft] = useState("");
  const tags = Array.isArray(value) ? value : [];

  const add = (raw) => {
    const t = (raw || "").trim().replace(/^#/, "");
    if (!t) return;
    if (!tags.some((x) => x.toLowerCase() === t.toLowerCase())) onChange([...tags, t]);
    setDraft("");
  };
  const remove = (t) => onChange(tags.filter((x) => x !== t));

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === "," ) {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && tags.length) {
      remove(tags[tags.length - 1]);
    }
  };

  const remaining = suggestions.filter(
    (s) => !tags.some((t) => t.toLowerCase() === s.toLowerCase())
  ).slice(0, 12);

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2 rounded-md border border-[#CBB4E4] bg-white p-2 min-h-[48px]">
        {tags.map((t) => (
          <span
            key={t}
            data-testid={`tag-chip-${t}`}
            className="inline-flex items-center gap-1.5 rounded-full bg-[#F1E4FA] text-[#632A8E] text-sm px-3 py-1"
          >
            #{t}
            <button type="button" onClick={() => remove(t)} aria-label={`${t} entfernen`} className="hover:text-[#D85CA4]">
              <X className="w-3.5 h-3.5" />
            </button>
          </span>
        ))}
        <input
          data-testid={testId}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={onKey}
          onBlur={() => add(draft)}
          placeholder={tags.length ? "" : "Tag eingeben und Enter drücken…"}
          className="flex-1 min-w-[140px] outline-none text-sm py-1 px-1 bg-transparent"
        />
      </div>
      {remaining.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          <span className="text-xs text-[#9A86B4] mr-1 self-center">Vorschläge:</span>
          {remaining.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => add(s)}
              data-testid={`tag-suggestion-${s}`}
              className="text-xs rounded-full border border-[#E7D8C6] px-2.5 py-0.5 text-[#6E5A82] hover:border-[#F4C542] hover:text-[#632A8E]"
            >
              #{s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
